import { Form, Col, Spinner } from "react-bootstrap";
import { ButtonStyled } from "../Button.styled";
import Text from "../../styled/Text";
import ReactFlagsSelect from "react-flags-select";
import { useState, useEffect } from "react";
import selectCountry from "../../utils/selectCountry";
import states from "../../json-data/state.json";
import * as yup from 'yup';
import 'yup-phone';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import useResponsiveDevice from '../useResponsiveDevice';
import { getLocation } from "../../utils/getLocation";
import {
  getDeviceDetails,
  getIpAddress,
  getPageURL,
  getUserAgent,
} from '../../utils/deviceInfoService';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Typeahead } from 'react-bootstrap-typeahead';
import { CITIES } from '../../constants/cities';
import { AppDispatch, store } from '../../redux/store';
import backendApi from '../../api/backendApi';
import { signUp } from '../../redux/loggedInUser/loggedInUser.actions';
import { CREATE_LEAD_POP_UP_QUERY } from '../../constants/queries/leads';
import { errorToast, successToast } from '../../utils/toasts';
import { Site_url } from "../../api/config";


const LeadCityLawyerForm = () => {

  const geolocation = useSelector(
    (store: RootState) => store.location.geolocation,
  );

  const [country, setCountry] = useState<string>(geolocation == 'in' ? 'IN' : 'US');
  const [code, setCode] = useState<string>(geolocation == 'in' ? '91' : '1');
  const [city, setCity] = useState<string>("");
  const [loading, setLoading] = useState(false)
  const [cityError, setCityError] = useState(false);
  const dispatch = useDispatch();
  const [deviceDetails, setDeviceDetails] = useState<any>({});
  const setCountryCode = (code: string) => {
    let country = selectCountry(code);
    setCode(country);
    setCountry(code);
  };
  const router = useRouter();
  const { isMobile } = useResponsiveDevice();

  let LeadCityLawyerFormSchema = (country == "IN") ? (yup.object().shape({
    fullName: yup.string().required('Name is required'),
    email: yup.string().email().required('Email is required'),
    // requirement: yup.string().required('Requirement Code is required'),
    mobile: yup
      .string()
      .phone()
      .test('len', (val: string | undefined, { createError, path }) =>
        val?.length === 10
          ? true
          : createError({
            path,
            message: 'Phone number should be valid and 10 digits long',
          }),
      )
      .required(),
    state: yup.string().required('State is required'),
  })) : (yup.object().shape({
    fullName: yup.string(),
    email: yup.string().email().required('Email is required'),
    // requirement: yup.string().required('Requirement Code is required'),
    mobile: yup
      .string()
      .required(),
  }));

  useEffect(() => {
    LeadCityLawyerFormSchema = (country == "IN") ? (yup.object().shape({
      fullName: yup.string(),
      email: yup.string().email().required('Email is required'),
      // requirement: yup.string().required('Requirement Code is required'),
      mobile: yup
        .string()
        .phone()
        .test('len', (val: string | undefined, { createError, path }) =>
          val?.length === 10
            ? true
            : createError({
              path,
              message: 'Phone number should be valid and 10 digits long',
            }),
        )
        .required(),
    })) : (yup.object().shape({
      fullName: yup.string(),
      email: yup.string().email().required('Email is required'),
      // requirement: yup.string().required('Requirement Code is required'),
      mobile: yup
        .string()
        .required(),
    }));
  }, [country]);

  // useEffect(()=>{
  //   let res = props?.title.split(" ").join("-").toLowerCase()+'-form';
  //   setPoaClass(res);
  // },[props.title]);

  useEffect(() => {
    const getDetails = async () => {
      const placement = router?.query?.placement
        ? router?.query?.placement
        : 'undefined';
      const ip = await getLocation();
      // const device = await getDeviceDetails();
      const result = {
        device: '',
        device_type: isMobile ? 'Mobile' : 'Desktop',
        ip_address: ip ? ip : '',
        path: getPageURL(),
        userAgent: getUserAgent(),
        placement: placement,
      };
      setDeviceDetails({ ...result });
    };
    getDetails();
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(LeadCityLawyerFormSchema),
    defaultValues: {
      fullName: '',
      email: '',
      mobile: '',
      requirement: '',
      state: '',
      city: ''
    },
  });
  const resetAllValue = () => {
    reset({
      fullName: '',
      email: '',
      mobile: '',
      requirement: '',
      state: '',
      city: ''
    });
    setCity("")
  }
  const onSubmit = async (data: any) => {
    const trackingData = store.getState()?.tracking;
    if(city == '' || city == undefined){
      setCityError(true)
    }else{
      // if (isLeadSubmmitButton.current) {
      //   return;
      // }
      // isLeadSubmmitButton.current = true;
      // setTimeout(() => {
      //   isLeadSubmmitButton.current = false;
      // }, 30000);
      try {
        setLoading(true)
        await backendApi.post('/', {
          query: CREATE_LEAD_POP_UP_QUERY,
          variables: {
            country: geolocation,
            country_code: parseInt(code),
            mobile: parseFloat(data.mobile),
            email: data.email,
            name: data.fullName,
            requirement: data.requirement,
            user_type: 'INDIVIDUAL',
            user_ip_address: deviceDetails?.ip_address?.query,
            user_agent: deviceDetails?.userAgent,
            page_url: deviceDetails?.path,
            device_type: deviceDetails?.device_type,
            concerned_area: null,
            // source: 'POA_LEAD',
            source: 'City Lead',
            city: city,
            state: data.state,
            concerned_area_category: null,
            placement: deviceDetails?.placement,
            utm: trackingData.UTM,
          },
        });
        dispatch(
          await signUp(
            {
              email: data.email,
              name:
                data.fullName && data.fullName !== '' ? data.fullName : 'User',
              mobile: parseFloat(data.mobile),
              countryCode: parseInt(code),
              type: 'INDIVIDUAL',
              user_ip_address: deviceDetails?.ip_address?.query,
              user_agent: deviceDetails?.userAgent,
              page_url: deviceDetails?.path,
              device_type: deviceDetails?.device_type,
              // source: 'POA_LEAD',
              source: 'City Lead',
              city: city,
              state: data.state,
              concerned_area: null,
              concerned_area_category: null,
              utm: trackingData.UTM,
            },
            () => {
              successToast(
                'Thank you for your interest. Our team will get back to you soon.',
              );
              const newPath = `${Site_url}legal-consultation`
              window.location.href = newPath ;
              setLoading(false)
              resetAllValue()
              // setPoaClass('popup-lead-form-submitted');
              // let res = props?.title.split(" ").join("-").toLowerCase()+'-form-submitted';
              // setPoaClass(res);
              // if (props.onHide) {
              //   props.onHide();
              // }
            },
            true,
          ),
        );
      } catch (e: any) {
        errorToast(e.message);
        setLoading(false)
      }
    }
  };

  return (
    <Form  onSubmit={handleSubmit(onSubmit)}>
      <Form.Group>
        {/* <Form.Label>
          <Text
            className="mb-0"
            fontSize="sm"
            weight="semibold"
            color="darkgray"
          >
            Your Name *
          </Text>
        </Form.Label> */}
        <input
          {...register('fullName')}
          className="form-control"
          data-clarity-unmask="True"
          placeholder="Enter your Full name"
        />
        {errors.fullName && (
          <Text color="red" fontSize="xs">
            {errors.fullName?.message}
          </Text>
        )}
      </Form.Group>

      <Form.Group>
        {/* <Form.Label>
          <Text
            className="mb-0"
            fontSize="sm"
            weight="semibold"
            color="darkgray"
          >
            Email Address *
          </Text>
        </Form.Label> */}
        <input
          {...register('email')}
          className="form-control"
          data-clarity-unmask="True"
          placeholder="Enter your Email Address"
        />
        {errors.email && (
          <Text color="red" fontSize="xs">
            {errors.email?.message}
          </Text>
        )}
        {/* <Form.Control type="email" placeholder="Enter your Email Address" /> */}
      </Form.Group>

      <Form.Group>
        <Form.Row>
          <Col xs='auto'>
            {/* <Form.Label>
              <Text
                className="mb-0 text-nowrap"
                fontSize="sm"
                weight="semibold"
                color="darkgray"
              >
                Country Code *
              </Text>
            </Form.Label> */}
            <ReactFlagsSelect
              selected={country}
              onSelect={(code) => {
                setCountryCode(code);
              }}
              countries={[
                "IN",
                "US",
                "GB",
                "CA",
                "ZA",
                "AU",
                "SG",
                "MY",
                "AE",
                "SA",
              ]}
              optionsSize={14}
              selectedSize={12}
              customLabels={{
                IN: "+91",
                US: "+1",
                GB: "+44",
                CA: "+1",
                ZA: "+27",
                AU: "+61",
                SG: "+65",
                MY: "+60",
                AE: "+971",
                SA: "+966",
              }}
            />
          </Col>
          <Col>
            {/* <Form.Label>
              <Text
                className="mb-0"
                fontSize="sm"
                weight="semibold"
                color="darkgray"
              >
                Mobile No. *
              </Text>
            </Form.Label> */}
            <input
              {...register('mobile')}
              className="form-control"
              data-clarity-unmask="True"
              placeholder="Mobile No."
            />
            {/* <Form.Control type="text" placeholder="Mobile No." /> */}
            {errors.mobile && (
              <Text color="red" fontSize="xs">
                Invalid mobile number
              </Text>
            ) 
            // : (
            //   <Text fontSize="xs">Enter a valid phone number</Text>
            // )
            }
          </Col>
        </Form.Row>
      </Form.Group>

      <Form.Group>
        {/* <Form.Label>
          <Text
            className="mb-0"
            fontSize="sm"
            weight="semibold"
            color="darkgray"
          >
            Let us know your requirement
          </Text>
        </Form.Label> */}
        <Form.Control
          as="textarea"
          placeholder="Describe your requirement"
          rows={3}
        />
      </Form.Group>
      {geolocation == 'in' ? (
        <Form.Group>
          <Form.Row style={{display: isMobile ? 'block' :"flex"}}>
            <Col>
              {/* <Form.Label>
                <Text
                  className="mb-0"
                  fontSize="sm"
                  weight="semibold"
                  color="darkgray"
                >
                  City *
                </Text>
              </Form.Label> */}
                <Typeahead
                  id="basic-typeahead-single"
                  {...register('city')}
                  placeholder="Enter your City"
                  onInputChange={(e) => {
                    if (e?.length > 0) {
                      setCityError(false)
                      setCity(e)
                    } else {
                      setCity('');
                    }
                  }}
                  onChange={(selected) => {
                    if (selected.length >= 1) {
                      setCityError(false)
                      setCity(selected[0].toString());
                    } else {
                      setCity('');
                    }
                  }}
                  // isInvalid={city == "" ? true : false}
                  options={CITIES}
                  defaultInputValue={city}
                />
                {cityError && (
                  <Text color="red" fontSize="xs">
                    City is required
                  </Text>
                )}
              {/* <Form.Control type="text" placeholder="Your city" /> */}
            </Col>

            <Col>
              {/* <Form.Label>
                <Text
                  className="mb-0"
                  fontSize="sm"
                  weight="semibold"
                  color="darkgray"
                >
                  State *
                </Text>
              </Form.Label> */}
              <select className={"form-control"} {...register('state')}>
                <option key={"default-state"} value={""}>
                  Select a state
                </option>
                {states.map((stateData: any) => (
                  <option key={stateData.state_code} value={stateData.state_code}>
                    {stateData.name}
                  </option>
                ))}
              </select>
              {errors.state && (
                <Text color="red" fontSize="xs">
                  {errors.state?.message}
                </Text>
              )}
            </Col>
          </Form.Row>
        </Form.Group>
      ) : (
        <Form.Group>
          <Form.Row>
            <Col>
              {/* <Form.Label>
                <Text
                  className="mb-0"
                  fontSize="sm"
                  weight="semibold"
                  color="darkgray"
                >
                  City *
                </Text>
              </Form.Label> */}
              <input
                className="form-control"
                placeholder="Your City"
                onChange={(e) => {
                  setCityError(false)
                  setCity(e.target.value);
                }}
                value={city}
              />
              {/* <Form.Control type="text" placeholder="Your city" /> */}
            </Col>

            <Col>
              {/* <Form.Label>
                <Text
                  className="mb-0"
                  fontSize="sm"
                  weight="semibold"
                  color="darkgray"
                >
                  State *
                </Text>
              </Form.Label> */}
              <input
                className="form-control"
                placeholder="Your State"
                {...register('state')}
              />
            </Col>
          </Form.Row>
        </Form.Group>
      )}

      <div className="d-flex justify-content-center align-items-center">
        {loading ? (
          <Spinner
            animation="border"
            color="#396AE8"
            style={{ color: '#396AE8' }}
          />
        ) : (
          <ButtonStyled color="#FFFFFF" backgroundColor="#396AE8" type="submit">
            Ask Lawyer
          </ButtonStyled>
        )}
        
      </div>
    </Form>
  );
};

export default LeadCityLawyerForm;
